import React, {useEffect, useState, useRef} from 'react';
import {Row, Col, Divider, DatePicker, message, PageHeader, Input, Button} from 'antd';
import {countStatistic} from '@/api/customer';
import CountLineChart from '@/page/customer/StatisticPage/CountLineChart';
import _ from 'lodash';
import dayjs from 'dayjs';
import {PageGrid} from '@/component';
import {getColumns} from './customerColumns';

import styles from './index.module.less';
import {useAuthStore} from '@/context/auth';

const {RangePicker} = DatePicker;

export default function CustomerStatistic() {
    const chartRef = useRef();
    const dateFormat = 'YYYY-MM-DD';
    const [sumaryRes, setSumaryRes] = useState([
        {title: '总人数', num: 0},
        {
            title: '今日新增',
            num: 0,
        },
        {title: '今日流失', num: 0},
    ]);
    const [authStore] = useAuthStore();
    const extId = _.get(authStore, 'user.extId');
    const [showSum, setShowSum] = useState(false);
    const [end, setEnd] = useState(dayjs().subtract(0, 'days').format(dateFormat));
    const [start, setStart] = useState(dayjs().subtract(10, 'days').format(dateFormat));
    const [searchParams, setSearchParams] = useState({
        startTime: start,
        endTime: end,
        userId: extId,
    });
    const [tableParams, setTableParams] = useState({
        userId: extId,
        s: '',
    });
    const [url, setUrl] = useState(null);
    const extra = (
        <Input.Group compact>
            <Input
                style={{width: '200px', background: '#fff'}}
                placeholder="请输入成员编号或名称"
                onChange={change}
            />
            <Button type="primary" onClick={search}>
                查询
            </Button>
        </Input.Group>
    );
    let columns = getColumns();
    useEffect(() => {
        init();
        // getChartData(start, end);
    }, []);

    function init() {
        setUrl('/customer/statistic/table');
        countStatistic(extId).then(res => {
            let temp = sumaryRes;
            temp[0].num = res.data.totalCount;
            temp[1].num = res.data.insCount;
            temp[2].num = res.data.losCount;
            setSumaryRes(temp);
            setShowSum(true);
        });
    }

    function change(e) {
        let temp = {...tableParams};
        temp.s = e.target.value;
        setTableParams(temp);
    }

    function search() {
        const {s, userId} = tableParams;
        setUrl(
            `/customer/statistic/table?s=${encodeURIComponent(s)}&userId=${encodeURIComponent(
                userId
            )}`
        );
    }

    function disabledDate(current) {
        // 同时最早记录为当天的180天前，最晚记录为昨天
        return current > dayjs().subtract(0, 'days') || current < dayjs().subtract(180, 'days');
    }

    function changeDate(date, dateStr) {
        if (dateStr[0] === '' || dateStr[1] === '') {
            message.error('请选择正确的时间');
            return;
        } else {
            // 开始时间和结束时间不能超过29天，
            const day = dayjs(date[1]).diff(dayjs(date[0]), 'days');
            if (day > 30) {
                message.error('日期选择不能超过30天');
                return;
            }
            setStart(dateStr[0]);
            setEnd(dateStr[1]);
            let temp = searchParams;
            searchParams.startTime = dateStr[0];
            searchParams.endTime = dateStr[1];
            setSearchParams(temp);
            console.log(chartRef);
            chartRef.current.reload(temp);
        }
    }

    function renderSumary() {
        return sumaryRes.map((res, i) => (
            <div className={styles.block} key={i}>
                <div className={styles.num}>{res.num}</div>
                <div className={styles.label}>{res.title}</div>
            </div>
        ));
    }

    return (
        <Row gutter={20}>
            <Col span={12}>
                <div className={styles.content} style={{height: '300px'}}>
                    <h3>企业全部客户数</h3>
                    <div className={styles.sumary}>{showSum && renderSumary()}</div>
                </div>
                <div className={styles.content} style={{height: '500px'}}>
                    <div className={styles.range}>
                        <h3>日新增趋势</h3>
                        <RangePicker
                            disabledDate={disabledDate}
                            onChange={changeDate}
                            defaultValue={[dayjs(start, dateFormat), dayjs(end, dateFormat)]}
                        />
                    </div>
                    <CountLineChart searchParams={searchParams} ref={chartRef} />
                </div>
            </Col>
            <Col span={12}>
                <div className={styles.content} style={{height: '820px', padding: '10px 20px'}}>
                    <PageHeader
                        title={<h3>成员客户统计</h3>}
                        extra={extra}
                        style={{padding: '0 0'}}
                    />
                    {url && (
                        <PageGrid
                            url={url}
                            columns={columns}
                            initParams={tableParams}
                            rowKey={'extId'}
                        />
                    )}
                </div>
            </Col>
        </Row>
    );
}
